import BasicTile from './basic-tile';

export default BasicTile;
